import gsap from '../../js/gsap/gsap.min.js';
import { ScrollTrigger } from '../../js/gsap/ScrollTrigger.min.js';
import "../../js/theme/_lenis.js";
import "../../js/theme/_swipers.js";
import { MotionPathPlugin } from '../../js/gsap/MotionPathPlugin.min.js';
 
gsap.registerPlugin(MotionPathPlugin);

const header = document.getElementById("wrapper-navbar"); 
   
header.classList.add("sticky");

function addClass() {
  header.classList.add('scrolling');
}
function removeClass() {
  header.classList.remove('scrolling')
}
ScrollTrigger.addEventListener('scrollStart', addClass)
ScrollTrigger.addEventListener('scrollEnd', removeClass)

const mainNav = document.querySelector('.home #main-nav');

if (mainNav) {
  // set initial state on load
  mainNav.classList.toggle('is-at-top', window.scrollY < 100);

  ScrollTrigger.create({
    start: 0,
    end: () => ScrollTrigger.maxScroll(window),
    onUpdate: (self) => {
      mainNav.classList.toggle('is-at-top', self.scroll() < 100);
    }
  });
}
  // === Scroll-triggered animation for large screens === 
  let mm = gsap.matchMedia();
 //mm.add("(min-width: 1200px)", () => {
    
 if (header.dataset.anim === 'animate-header') {
    const showAnim = gsap.from(header, {
      y: -177,
      paused: true,
      duration: 0.8,
      ease: "power2.out"
    }).progress(1);

    ScrollTrigger.create({
      start: '100px',
      end: () => ScrollTrigger.maxScroll(window) + 10,
    
      onUpdate: (self) => {
    
        if (self.scroll() < 100) {
          header.classList.remove('up-scroll');
          showAnim.progress(1); 
          return;
        }
    
        if (self.direction === -1) {
          showAnim.play();
          header.classList.add('up-scroll');
        } else {
          showAnim.reverse();
          header.classList.remove('up-scroll');
        }
      },
    
      onLeave: () => showAnim.play()
    });
  }
  //});
 

  const menuItems = document.querySelectorAll('#wrapper-navbar .menu-item > a');
  const bigMenu = document.querySelector('.big-menu');
  const wrapperNavbar = document.getElementById('wrapper-navbar');
  const contentSections = document.querySelectorAll('.menu-content');
  const logoWrapper = document.querySelector('.flex-logo-wrapper');
  let timer;
  mm.add("(min-width: 1200px)", () => {
    let activeItem = null;
    let openTimer;
    let closeTimer;
    function sanitizeTitle(title) {
      return title
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');
    }
  
    // function openBigMenu() {
    //   if (!bigMenu.classList.contains('is-open')) {
    //     bigMenu.classList.add('is-open');
    //     gsap.to(bigMenu, { 
    //       height: '25rem',
    //       //duration: 0.6,
    //       //ease: 'power2.out'
    //     });
    //   }
    // }

    function openBigMenu() {
      clearTimeout(closeTimer);
      clearTimeout(openTimer);
    
      if (!bigMenu.classList.contains('is-open')) {
        bigMenu.classList.add('is-open');
    
        gsap.killTweensOf(bigMenu);
    
        gsap.to(bigMenu, {
          height: '25rem',
          duration: 0.45,
          ease: 'power2.out'
        });
      }
    }
  
    // function closeBigMenu() {
    //   if (bigMenu.classList.contains('is-open')) {
    //     gsap.to(bigMenu, {
    //       height: 0,
    //       //duration: 0.6,
    //       // ease: 'power2.in',
    //       onComplete: () => {
    //         bigMenu.classList.remove('is-open');
    //       }
    //     });
    //   }
    // }

    function closeBigMenu() {
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
    
      closeTimer = setTimeout(() => {
        if (bigMenu.classList.contains('is-open')) {
    
          gsap.killTweensOf(bigMenu);
    
          gsap.to(bigMenu, {
            height: 0,
            duration: 0.35,
            ease: 'power2.in',
            onComplete: () => {
              bigMenu.classList.remove('is-open');
            }
          });
        }
      }, 250); 
    }
  
    function removeHoverClasses() {
      document.querySelectorAll('#wrapper-navbar .menu-item.hover-on')
        .forEach(item => item.classList.remove('hover-on'));
    }
  
    menuItems.forEach(link => {
      const menuItem = link.closest('.menu-item');
      const hasChildren = menuItem.classList.contains('menu-item-has-children');
      const titleAttr = link.getAttribute('title');
      const targetContent = document.getElementById(sanitizeTitle(titleAttr));
  
      // --------------------
      // Hover behavior
      // --------------------

      // link.addEventListener('mouseenter', () => {
      //   timer = setTimeout(() => {
      //   if (hasChildren) {
      //     // If already open and hovering a different parent, keep it open and swap content
      //     openBigMenu();
      //     removeHoverClasses();
      //     menuItem.classList.add('hover-on');
      //     contentSections.forEach(section => section.classList.remove('show'));
      //     if (targetContent) targetContent.classList.add('show');
      //     activeItem = link;
      //   } else {
      //     // Hovering a menu item without children closes big menu
      //     closeBigMenu();
      //     removeHoverClasses();
      //     contentSections.forEach(section => section.classList.remove('show'));
      //     activeItem = null;
      //   }}, 150); 
      // });
      link.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
      
        openTimer = setTimeout(() => {
          if (hasChildren) {
            openBigMenu();
            removeHoverClasses();
            menuItem.classList.add('hover-on');
            contentSections.forEach(section => section.classList.remove('show'));
            if (targetContent) targetContent.classList.add('show');
            activeItem = link;
          } else {
            closeBigMenu();
            removeHoverClasses();
            contentSections.forEach(section => section.classList.remove('show'));
            activeItem = null;
          }
        }, 250); // 👈 stronger intent delay
      });
      // --------------------
      // Click behavior 
      // --------------------
      link.addEventListener('click', (e) => {
        if (hasChildren) {
          e.preventDefault();
  
          if (activeItem === link) {
            // Clicking the same item closes the menu
            closeBigMenu();
            contentSections.forEach(section => section.classList.remove('show'));
            removeHoverClasses();
            activeItem = null;
          } else {
            // Open and show corresponding content
            openBigMenu();
            removeHoverClasses();
            menuItem.classList.add('hover-on');
            contentSections.forEach(section => section.classList.remove('show'));
            if (targetContent) targetContent.classList.add('show');
            activeItem = link;
          }
        } else {
          // Clicking a no-child item closes big menu
          closeBigMenu();
          removeHoverClasses();
          contentSections.forEach(section => section.classList.remove('show'));
          activeItem = null;
        }
      });
    });
  
    // --------------------
    // Handle mouse leave
    // --------------------
    // [bigMenu, wrapperNavbar].forEach(el => {
    //   el.addEventListener('mouseleave', (e) => {
    //     clearTimeout(timer);
    //     const isOutside =
    //       !bigMenu.contains(e.relatedTarget) &&
    //       !wrapperNavbar.contains(e.relatedTarget);
  
    //     if (isOutside) {
    //       closeBigMenu();
    //       removeHoverClasses();
    //       contentSections.forEach(section => section.classList.remove('show'));
    //       activeItem = null;
    //     }
    //   });
    // });
    [bigMenu, wrapperNavbar].forEach(el => {
      el.addEventListener('mouseleave', (e) => {
    
        clearTimeout(openTimer);
    
        const isOutside =
          !bigMenu.contains(e.relatedTarget) &&
          !wrapperNavbar.contains(e.relatedTarget);
    
        if (!isOutside) return;
    
        closeTimer = setTimeout(() => {
          closeBigMenu();
          removeHoverClasses();
          contentSections.forEach(section => section.classList.remove('show'));
          activeItem = null;
        }, 250); // 👈 tolerance window
      });
    
      el.addEventListener('mouseenter', () => {
        clearTimeout(closeTimer);
      });
    });

    const topMenuContainer = document.getElementById('top-menu-container');

    if (topMenuContainer) {
      topMenuContainer.addEventListener('mouseenter', () => {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
  
        closeBigMenu();
        removeHoverClasses();
        contentSections.forEach(section => section.classList.remove('show'));
        activeItem = null;
      });
    }
    topMenuContainer.addEventListener('mouseover', () => {
      console.log('Mouse entered topMenuContainer');
    });
  if (logoWrapper) {
    logoWrapper.addEventListener('mouseenter', () => {
      closeBigMenu();
      removeHoverClasses();
      contentSections.forEach(section => section.classList.remove('show'));
      activeItem = null;
    });
  }

  
  
    // --------------------
    // Close when clicking outside
    // --------------------
    document.addEventListener('click', (e) => {
      const isClickInside =
        bigMenu.contains(e.target) || wrapperNavbar.contains(e.target);
      if (!isClickInside) {
        closeBigMenu();
        removeHoverClasses();
        contentSections.forEach(section => section.classList.remove('show'));
        activeItem = null;
      }
    });
  
    // --------------------
    // Close on scroll
    // --------------------
    let scrollTimeout;
    window.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        if (bigMenu.classList.contains('is-open')) {
          closeBigMenu();
          contentSections.forEach(section => section.classList.remove('show'));
          activeItem = null;
        } 
      }, 50);
    });


    document.querySelectorAll('.nav-link').forEach(link => {
      // find direct text nodes (not inside other elements)
      const textNodes = [...link.childNodes].filter(node =>
        node.nodeType === Node.TEXT_NODE && node.textContent.trim() !== ''
      );
    
      textNodes.forEach(textNode => {
        const span = document.createElement('div');
        span.className = 'nav-text mt-xl-1';
        span.textContent = textNode.textContent.trim();
    
        link.replaceChild(span, textNode);
      });
    });

  });




menuItems.forEach(link => {
  const parentItem = link.closest('.menu-item');
  const isTopLevelWithChildren = parentItem.classList.contains('menu-item-has-children') &&
                                 !parentItem.closest('.dropdown-menu');
  if (isTopLevelWithChildren) {
    if (!link.querySelector('.navigation-icon')) {
      const navIcon = document.createElement('div');
      navIcon.className = 'navigation-icon ms-xl-2 ms-auto';
      navIcon.innerHTML = `
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19.6889 12.0673L19.6889 9.10341L12.0674 9.10341L12.0674 1.48194H9.10351L9.10351 9.10341L1.48204 9.10341L1.48202 12.0673L9.10348 12.0673L9.10348 19.6888H12.0674L12.0674 12.0673L19.6889 12.0673Z" fill="#F15A29"></path>
        </svg>
      `;
      link.appendChild(navIcon);
    }
  }
});


if (jQuery('.line').length > 0) {

  const lines = document.querySelectorAll('.line-inner');

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Animate with GSAP
        gsap.to(entry.target, {
          width: "52px",
          duration: 1,
          ease: "power2.out"
        });

        // Stop observing after animation starts
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1
  });

  lines.forEach(line => observer.observe(line));

}


// Images parallax
gsap.utils.toArray('.parallax-inner').forEach(container => {
  const img = container.querySelector('img');

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: container,
      scrub: true,
      pin: false,
    }
  });

  tl.fromTo(img, {
    yPercent: -10,
    ease: 'none'
  }, {
    yPercent: 10,
    ease: 'none'
  });
});

if (document.querySelector("section") != null) {
  const coptions = {
    root: null,
  };

  let revealCallback = (entries) => {
    entries.forEach((entry) => {
      let container = entry.target;
      if (entry.isIntersecting) {
        // Check if there's a data-delay attribute
        let delay = container.getAttribute('data-delay');
        if (delay) {
          container.style.animationDelay = delay;
        }
        container.classList.add("fadeInUp");
      }
    });
  };

  let revealObserver = new IntersectionObserver(revealCallback, coptions);

  document.querySelectorAll(".animated").forEach((reveal) => {
    revealObserver.observe(reveal);
  });
}

const callout = document.querySelector(".mobile-callout");

if (window.innerWidth <= 1200 && callout) {
  let isHidden = false; // Track if callout is currently hidden

  // Animate in on load
  gsap.fromTo(callout, 
    { y: "100%" }, // start fully off screen
    { y: 0, duration: 0.6, ease: "power3.out", delay: 0.2 }
  );

  ScrollTrigger.create({
    trigger: document.body,
    start: "top top",
    onUpdate: (self) => {
      // Scroll down
      if (self.direction === 1 && !isHidden) {
        isHidden = true;
        gsap.to(callout, {
          y: "100%", // Show only 1rem
          duration: 0.5,
          ease: "power3.inOut"
        });
      }
      // Scroll up
      else if (self.direction === -1 && isHidden) {
        isHidden = false;
        gsap.to(callout, {
          y: 0,
          duration: 0.5,
          ease: "power3.inOut"
        });
      }
    }
  });
}



// MAP
if (jQuery('.map-box').length > 0) {
  const points = document.querySelectorAll('#points path');
  const mapBox = document.querySelector('.map-box');
  const mapContents = document.querySelectorAll('.map-box__content');
  const close = document.querySelector('.map-box .close');
  const linePaths = document.querySelectorAll('#lines path');

  close.addEventListener('click', () => {
    mapBox.classList.remove('active');
    gsap.to('#lines', { opacity: 1, duration: 0.5 });
  });

  points.forEach(point => {
    point.addEventListener('click', () => {
      const pointId = point.id.toLowerCase();
      console.log(pointId);
      const matchedContent = document.querySelector(`.map-box__content[data-id="${pointId}"]`);

      if (matchedContent) {
        mapContents.forEach(content => content.style.display = 'none');
        matchedContent.style.display = 'block';

        const titleText = point.id
        .replace(/_/g, ' ')        // remove underscores → spaces
        .toLowerCase()
        .replace(/\b\w/g, c => c.toUpperCase());
      
      const titleTextUpper = titleText.toUpperCase();
        matchedContent.querySelector('.map-box__title h3').textContent = titleTextUpper;
        matchedContent.querySelector('.contact-title').textContent = titleText;

        gsap.to('#lines', { opacity: 0.2, duration: 0.5 });

        if (!mapBox.classList.contains('active')) {
          gsap.from(mapBox, {
            scale: 0,
            transformOrigin: "50% 50%",
            duration: 0.6,
            ease: "power2.out"
          });
        }

        mapBox.classList.add('active');
        gsap.from([
          matchedContent.querySelector('.map-box__title'),
          matchedContent.querySelector('.map-box__items'),
          matchedContent.querySelector('.map-box__contact')
        ], {
          y: 40,
          opacity: 0,
          duration: 0.4,
          stagger: 0.1,
          ease: "power2.out"
        });

      } else {
        mapBox.classList.remove('active');
        gsap.to('#lines', { opacity: 1, duration: 0.5 });
      }
    });
  });

}



// Only run if #map-container exists
const mapContainer = document.querySelector("#map-container");
if (mapContainer) {

  const points = Array.from(document.querySelectorAll("#points path"));
  const connectionsGroup = document.querySelector("#connections");

  function getCenter(el) {
    const bbox = el.getBBox();
    return {
      x: bbox.x + bbox.width / 2,
      y: bbox.y + bbox.height / 2
    };
  }

  function createCurvedPath(a, b) {
    const dx = b.x - a.x;
    const dy = b.y - a.y;
    return `
      M ${a.x} ${a.y}
      Q ${a.x + dx / 2 + dy * 0.2} ${a.y + dy / 2 - dx * 0.2}
        ${b.x} ${b.y}
    `;
  }

  function connectPoints(pointA, pointB) {
    const a = getCenter(pointA);
    const b = getCenter(pointB);

    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", createCurvedPath(a, b));
    path.setAttribute("class", "connection-path");

    connectionsGroup.appendChild(path);

    const length = path.getTotalLength();
    path.style.strokeDasharray = length;
    path.style.strokeDashoffset = length;

    const tl = gsap.timeline({
      onComplete: () => {
        gsap.to(path, {
          opacity: 0,
          duration: 1,
          onComplete: () => path.remove()
        });
      }
    });

    tl.to(path, {
      opacity: 1,
      strokeDashoffset: 0,
      duration: 1.2,
      ease: "power2.out"
    });

    tl.to(
      path,
      {
        strokeDashoffset: -length,
        duration: 2,
        ease: "none"
      },
      "<"
    );

    return tl;
  }

  function randomPair() {
    let a = points[Math.floor(Math.random() * points.length)];
    let b = points[Math.floor(Math.random() * points.length)];
    while (a === b) {
      b = points[Math.floor(Math.random() * points.length)];
    }
    return [a, b];
  }

  let networkInterval = null;

  function startNetwork() {
    if (networkInterval) return;

    networkInterval = setInterval(() => {
      if (document.visibilityState !== "visible") return;

      const connectionsCount = Math.floor(Math.random() * 3) + 1;
      for (let i = 0; i < connectionsCount; i++) {
        const [a, b] = randomPair();
        connectPoints(a, b);
      }
    }, 1200);
  }

  function stopNetwork() {
    clearInterval(networkInterval);
    networkInterval = null;
  }

  const svgElement = document.querySelector("#connections");
  if (svgElement) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            startNetwork();
          } else {
            stopNetwork();
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(svgElement);
  }

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      startNetwork();
    } else {
      stopNetwork();
    }
  });

} 

